export { InjectionMode, Stylesheet, concatStyleSets, fontFace, keyframes, mergeStyleSets, mergeStyles } from '@uifabric/merge-styles';
//# sourceMappingURL=MergeStyles.js.map